'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Modal = {
  init: function init(p) {
    p = p || document;
    p.addEventListener('engage:action', function (e) {
      var a = e.detail.info.attributes[0];

      if (!!a && !!a.att && a.att == 'data-active-modal') {

        if (_n.exists('[data-modal].active')) {
          _n.qs('[data-modal].active').classList.remove('active');
        }

        if (_n.exists('[data-modal="' + a.set + '"]')) {
          _n.qs('[data-modal="' + a.set + '"]').classList.add('active');
          if (_n.exists('[data-modal="' + a.set + '"] input')) {
            _n.qs('[data-modal="' + a.set + '"] input').focus();
          } else {
            _n.qs('[data-modal="' + a.set + '"]').focus();
          }
        }
      }
    });
  },
  open: function open(m) {
    Neptune.engage.action(_n.qs('body'), { attributes: { att: 'data-active-modal', set: m } });
  },
  close: function close() {
    Neptune.engage.action(_n.qs('body'), { attributes: { att: 'data-active-modal', set: '_remove' } });
  }
};
window.modal = Modal;
exports.default = Modal;